import { Component, OnInit, Input } from '@angular/core';

@Component({
    selector: 'app-loading',
    templateUrl: './loading.component.html',
    styleUrls: [],
    standalone: false
})
export class LoadingComponent {

  @Input() isLoading = true;

  constructor() { }

}
